import { render, staticRenderFns } from "./mobileSiteMenu.vue?vue&type=template&id=5bf255b2&scoped=true"
import script from "./mobileSiteMenu.vue?vue&type=script&lang=js"
export * from "./mobileSiteMenu.vue?vue&type=script&lang=js"
import style0 from "./mobileSiteMenu.vue?vue&type=style&index=0&id=5bf255b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf255b2",
  null
  
)

export default component.exports